import script from "./FileUploadButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploadButton.vue?vue&type=script&setup=true&lang=js"

import "./FileUploadButton.vue?vue&type=style&index=0&id=09cce674&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09cce674"]])

export default __exports__